module.exports = __webpack_public_path__ + "static/media/bodiometer-logo-stacked.279dd47a.svg";